const mmEmail = 'kontakt@mojamatura.edu.pl';

export default mmEmail;
